const DateComponent = () => {
  const today = new Date();

  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const formattedDate = today.toLocaleDateString("pl-PL", options);

  return <p className="p4">&nbsp;&nbsp;&nbsp;{formattedDate}</p>;
};

export default DateComponent;
